import { render, staticRenderFns } from "./CompanyCreate.vue?vue&type=template&id=3c32f406&scoped=true&"
import script from "./CompanyCreate.vue?vue&type=script&lang=js&"
export * from "./CompanyCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c32f406",
  null
  
)

export default component.exports